export default class HeaderState {
    constructor() {

        this.header = document.querySelector('header');

        if(this.header === null)  return;
        this.bnBurger = document.querySelector('.js-open-navigation-mobile');
        this.nav = document.querySelector('nav');
        this.projectMenu = document.querySelector('.js-open-project');
        this.lastScrollTop = 70;

        this.navLi = this.nav.querySelector('ul').children;
        this.navLiWithChildren = this.nav.querySelectorAll('.with-submenu');

        Array.prototype.forEach.call(this.navLiWithChildren, (elLi) => {
            elLi.addEventListener('click', this.openSubmenu.bind(this), false);
        });

        this.projectMenu.addEventListener('click', () => { 
            this.openProjectMenu()
        });

        this.bnBurger.addEventListener('click', () => { 
            this.openMenuMobile()
        });

        this.scrollPage();

        document.addEventListener( 'scroll', ()  => { this.scrollPage() ; });
    }

    scrollPage() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        this.scrollDirection(scrollTop);

        this.lastScrollTop = scrollTop <= 70 ? 70 : scrollTop;

    }

    scrollDirection(scrollTop) {
        if(scrollTop === 0) {
            this.header.classList.remove('header-scroll');
            return;
        }

        if (scrollTop > this.lastScrollTop){
            this.header.classList.add('header-scroll');
        }
    }

    openMenuMobile() {
        document.querySelector('body').classList.contains('open-menu') ? document.querySelector('body').classList.remove('open-menu') : document.querySelector('body').classList.add('open-menu');

        Array.prototype.forEach.call(this.navLiWithChildren, (elLi) => {
            elLi.classList.remove('open-submenu');
        });
    }

    openSubmenu(event) {
        if( !event.target.classList.contains('open-submenu')) {
            Array.prototype.forEach.call(this.navLiWithChildren, (elLi) => {
                elLi.classList.remove('open-submenu');
            });
            event.target.classList.add('open-submenu');
        }
        else if(event.target.classList.contains('open-submenu')) {
            event.target.classList.remove('open-submenu');
        }
    }

    openProjectMenu() {
        this.projectMenu.classList.toggle('open-project-submenu');
    }
}